/**
 * Application configuration
 * All values are loaded from environment variables
 */

// Load-safe when bundled into Medplum bots (esbuild CJS turns import.meta into {}).
const env: Partial<ImportMetaEnv> = import.meta.env ?? {};

export const config = {
  // Environment
  profile: env.VITE_PROFILE || 'development',
  isDevelopment: env.VITE_PROFILE === 'development',
  isStaging: env.VITE_PROFILE === 'staging',
  isProduction: env.VITE_PROFILE === 'production',

  // Medplum
  medplum: {
    baseUrl: (env.VITE_MEDPLUM_BASE_URL || 'https://api.medplum.com/').trim(),
    /** Trimmed — pilot Users are project-scoped; login must include clientId or projectId from env. */
    clientId: (env.VITE_MEDPLUM_CLIENT_ID || '').trim(),
    /**
     * OAuth client secret for `startClientLogin` when no interactive user session.
     * Exposed in the browser bundle — use only for local/dev; production should use a backend or Medplum-hosted proxy.
     */
    clientSecret: (env.VITE_MEDPLUM_CLIENT_SECRET || '').trim(),
    /**
     * Guest join's own ClientApplication (`/join/:code`, client_credentials). Its only membership grants
     * executing `chime-guest-join`; the SPA client above has none (P7-A design Decision 38). Public, like the
     * SPA secret.
     */
    guestClientId: (env.VITE_MEDPLUM_GUEST_CLIENT_ID || '').trim(),
    guestClientSecret: (env.VITE_MEDPLUM_GUEST_CLIENT_SECRET || '').trim(),
    projectId: (env.VITE_MEDPLUM_PROJECT_ID || '').trim(),
    /** Single patient ID used for all assessment assignments and client portal documents (seed patient). */
    clientPatientId: '11111111-1111-4111-a111-111111111111',
  },

  // Auth0
  auth0: {
    domain: env.VITE_AUTH0_DOMAIN || '',
    clientId: env.VITE_AUTH0_CLIENT_ID || '',
    audience: env.VITE_AUTH0_AUDIENCE || '',
    // Auth0 authorize URL constructed from domain
    get authorizeUrl() {
      return `https://${env.VITE_AUTH0_DOMAIN}/authorize`;
    },
  },

  // Application
  app: {
    url: env.VITE_APP_URL || 'http://localhost:3015',
    callbackUrl: env.VITE_CALLBACK_URL || 'http://localhost:3015/auth/callback',
  },

  // Backend API
  api: {
    url: env.VITE_API_URL || 'http://localhost:8080',
  },
} as const;
